import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/ratings";
const apiDeleteEndpoint = API_BASE_URL_ENV() + "/admin/user/developer/ratings";
const apiToggleEndpoint = API_BASE_URL_ENV() + "/admin/user/developer/ratings/status";


export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
   deleteDeveloperRate=(id)=>{
   return    http.delete(`${apiDeleteEndpoint}/${id}`)
   }

   toggleActivation = (id,data) => {
    return http.post(`${apiToggleEndpoint}/${id}`, data)
}

}
